import { StylesConfig } from 'react-select'
import {
  Primary,
  Secondary,
  shadows,
  spacing,
  roboto,
} from '@sphinx/components-styles'

export const selectCustomStyles: Partial<StylesConfig> = {
  control: (provided, { isDisabled, isFocused }) => ({
    ...provided,
    backgroundColor: isDisabled ? Primary.navy[5] : Primary.neutral.white,
    borderRadius: '2px',
    borderColor: isDisabled
      ? Primary.navy[5]
      : isFocused
      ? Primary.orange[100]
      : Primary.navy[40],
    boxShadow: isFocused ? `0 0 0 1px ${Primary.orange[100]}` : null,
    fontFamily: roboto,
    fontSize: '12px',
    minHeight: '30px',
    '&:hover': {
      borderColor: isFocused ? Primary.orange[100] : Primary.navy[100],
    },
  }),
  input: (provided, { isDisabled }) => ({
    ...provided,
    fontFamily: roboto,
    fontSize: '12px',
    color: isDisabled ? Primary.navy[20] : Primary.navy[100],
  }),
  dropdownIndicator: (provided, { isDisabled, isFocused }) => ({
    ...provided,
    padding: '5px',
    color: isDisabled
      ? Primary.navy[20]
      : isFocused
      ? Primary.orange[100]
      : Primary.navy[100],
    '&:hover': {
      color: isFocused ? Primary.orange[100] : Primary.navy[100],
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: Primary.navy[20],
  }),
  singleValue: (provided, { isDisabled }) => ({
    ...provided,
    color: isDisabled ? Primary.navy[20] : Primary.navy[100],
  }),
  menu: (provided, { options }) => ({
    ...provided,
    backgroundColor: Primary.neutral.white,
    borderRadius: '2px',
    border: 'none',
    boxShadow: shadows.level8,
    height: options && options.length === 0 && 0,
  }),
  option: (provided, { isSelected, isFocused, isDisabled }) => ({
    ...provided,
    backgroundColor: isSelected
      ? Primary.orange[20]
      : isFocused
      ? Primary.navy[5]
      : 'inherit',
    color: isDisabled ? Primary.navy[20] : Primary.navy[100],
    fontFamily: roboto,
    fontSize: '12px',
    lineHeight: '24px',
    padding: spacing.xxs,
    ':active': {
      backgroundColor: !isDisabled && Primary.orange[20],
    },
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    display: 'none',
  }),
  loadingMessage: (provided) => ({
    ...provided,
    display: 'none',
  }),
}

export const invalidStateStyles: Partial<StylesConfig> = {
  control: (provided) => ({
    ...provided,
    backgroundColor: Secondary.red[10],
    borderColor: Secondary.red[100],
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '5px',
    color: Secondary.red[100],
    '&:hover': {
      color: Secondary.red[100],
    },
  }),
}
